import { BrowserStorage } from './base-storage';

export const browserSessionStorage = new BrowserStorage('sessionStorage');
